export default "__VITE_ASSET__B4kbzEl6__"